import React, { useState } from "react";
import Slider from "react-slick";
import { Icon } from "@iconify/react";
import { faIR } from "date-fns/locale";
import { useTranslation } from "react-i18next";

// Custom Arrow components
const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <span style={{ color: "white", fontSize: "18px" }}>
        <Icon icon="mingcute:right-line" />
      </span>
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        zIndex: 1,
      }}
      onClick={onClick}
    >
      <span style={{ color: "white", fontSize: "18px" }}>
        <Icon icon="mingcute:left-line" />
      </span>
    </div>
  );
};

function SliderCategory({ items, handleFilterChange, selectedPropertyTypes }) {

  const handleItemClick = (index, value) => {
    if (selectedPropertyTypes.includes(value)) {
      handleFilterChange(
        "propertyType",
        selectedPropertyTypes.filter((type) => type !== value),
        true
      );
    } else {
      handleFilterChange(
        "propertyType",
        [...selectedPropertyTypes, value],
        true
      );
    }
  };
  const { t, i18n } = useTranslation();
  const adjustedSlidesToShow = items && items.length === 1 ? 1 : Math.min(items.length, 9);
  const currentLanguage = i18n.language; 
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    draggable: false,
    variableWidth: false,

    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: adjustedSlidesToShow > 6 ? 6 : adjustedSlidesToShow,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: adjustedSlidesToShow > 5 ? 5 : adjustedSlidesToShow,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: adjustedSlidesToShow > 3 ? 3 : adjustedSlidesToShow,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: adjustedSlidesToShow > 2.5 ? 2.5 : adjustedSlidesToShow,
        },
      },
    ],
  };



  return (
    <div className={`slider-container ${items && items.length === 1 ? "centered-slider" : ""}`}>
     <Slider {...settings}>
      {items &&
        items.length > 0 &&
        items.filter((val) => val.property_count > 0).map((item, index) => (
          <div
            className={`slider-item ${selectedPropertyTypes.includes(item.id) ? "selected" : ""}`}
            key={index}
            onClick={() => handleItemClick(index, item.id)}
          >
            <div className="categoryBox">
              {item.icon}
              <h3 className="text-capitalize">
                {currentLanguage === "he" ? item.title : item.eng_title}
              </h3>
              <h4 className="slider_badge">{item.property_count}</h4>
            </div>
          </div>
        ))}
    </Slider>
    </div>
  );
}

export default SliderCategory;




